import React from "react";

export interface AttendanceStats {
  present: number;
  absent: number;
  online: number;
  pending: number;
}

interface AttendanceStatsGridProps {
  stats: AttendanceStats;
}

const ATTENDANCE_CARD_CONFIG = [
  {
    key: "present",
    label: "PRESENT",
    bgColor: "#e6f7ed",
    borderColor: "#b7ebca",
    textColor: "#137333",
  },
  {
    key: "absent",
    label: "ABSENT",
    bgColor: "#fde8e8",
    borderColor: "#f8b4b4",
    textColor: "#c5221f",
  },
  {
    key: "online",
    label: "ONLINE",
    bgColor: "#fff8e6",
    borderColor: "#ffe58f",
    textColor: "#d46b08",
  },
  {
    key: "pending",
    label: "PENDING",
    bgColor: "#ffffff",
    borderColor: "#e5e7eb",
    textColor: "#374151",
  },
] as const;

const AttendanceStatsGrid: React.FC<AttendanceStatsGridProps> = ({ stats }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "10px",
        padding: "0 16px",
        marginTop: "-28px",
        position: "relative",
        zIndex: 10,
      }}
    >
      {ATTENDANCE_CARD_CONFIG.map((card) => (
        <div
          key={card.key}
          style={{
            backgroundColor: card.bgColor,
            border: `1.5px solid ${card.borderColor}`,
            borderRadius: "14px",
            padding: "10px 4px",
            textAlign: "center",
            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: 800,
              color: card.textColor,
              lineHeight: 1.1,
            }}
          >
            {stats[card.key]}
          </div>

          <div
            style={{
              fontSize: "9px",
              fontWeight: 700,
              color: card.textColor,
              marginTop: "4px",
              letterSpacing: "0.4px",
            }}
          >
            {card.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AttendanceStatsGrid;
